// dashboard/src/components/dashboard/api-keys/ApiKeysList.tsx
import React from 'react';
import { ApiKey } from '../../../services/apiKeyService';
import { format } from 'date-fns';

interface ApiKeysListProps {
  apiKeys: ApiKey[];
  onRevoke: (keyId: string) => void;
  isLoading: boolean;
}

const ApiKeysList: React.FC<ApiKeysListProps> = ({ apiKeys, onRevoke, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <div className="px-4 py-5 sm:p-6 flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-500"></div>
        </div>
      </div>
    );
  }

  if (apiKeys.length === 0) {
    return (
      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <div className="px-4 py-5 sm:p-6 text-center">
          <p className="text-gray-500">No API keys found. Create your first API key to get started.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-md">
      <ul className="divide-y divide-gray-200">
        {apiKeys.map((key) => (
          <li key={key.id}>
            <div className="px-4 py-4 sm:px-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className={`flex-shrink-0 h-4 w-4 rounded-full ${key.is_active ? 'status-active' : 'status-inactive'}`}></div>
                  <p className="ml-2 text-sm font-medium text-primary-600 truncate">{key.key_name || 'Unnamed Key'}</p>
                </div>
                <div className="ml-2 flex-shrink-0 flex">
                  {key.is_active ? (
                    <button
                      onClick={() => onRevoke(key.id)}
                      className="ml-2 btn-sm btn-outline-error"
                    >
                      Revoke
                    </button>
                  ) : (
                    <span className="px-2.5 py-1.5 text-xs font-medium rounded text-gray-700 bg-gray-100">
                      Revoked
                    </span>
                  )}
                </div>
              </div>
              <div className="mt-2 sm:flex sm:justify-between">
                <div className="sm:flex">
                  <p className="flex items-center text-sm text-gray-500">
                    Created: {format(new Date(key.created_at), 'MMM d, yyyy')}
                  </p>
                </div>
                <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                  {key.last_used_at ? (
                    <p>Last used: {format(new Date(key.last_used_at), 'MMM d, yyyy')}</p>
                  ) : (
                    <p>Never used</p>
                  )}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ApiKeysList;
